import { useCallback, useEffect, useState } from 'react';
import { Link } from 'react-router-dom';
import { ADMIN_GATEWAY_URL, getAdminCatalogue, getAdminSession, openAdminSignIn, type AdminCatalogue, type AdminSession } from '../lib/adminGateway';

export function Admin(): JSX.Element {
  const [session, setSession] = useState<AdminSession | null>(null);
  const [catalogue, setCatalogue] = useState<AdminCatalogue | null>(null);
  const [status, setStatus] = useState<'loading' | 'ready' | 'signed-out' | 'unavailable'>('loading');
  const load = useCallback(async (): Promise<void> => {
    if (!ADMIN_GATEWAY_URL) { setStatus('unavailable'); return; }
    setStatus('loading');
    try {
      const nextSession = await getAdminSession();
      setSession(nextSession);
      setCatalogue(await getAdminCatalogue());
      setStatus('ready');
    } catch (error) {
      setCatalogue(null);
      setSession(null);
      setStatus(error instanceof Error && error.message.includes('authentication') ? 'signed-out' : 'unavailable');
    }
  }, []);
  useEffect(() => { void load(); const onFocus = (): void => { void load(); }; window.addEventListener('focus', onFocus); return () => window.removeEventListener('focus', onFocus); }, [load]);
  return (
    <div className="stack">
      <h1 className="page-title">Administrator</h1>
      <p className="page-lead">Read-only privileged catalogue tools.</p>
      {status === 'loading' ? <p className="hint" role="status">Checking administrator access…</p> : null}
      {status === 'signed-out' ? <section className="card stack"><h2 className="mt-0">Sign in required</h2><p>You must authenticate through the approved Cloudflare Access policy.</p><button type="button" className="btn btn-primary" onClick={openAdminSignIn}>Sign In</button></section> : null}
      {status === 'unavailable' ? <section className="card stack" role="alert"><h2 className="mt-0">Administrator unavailable</h2><p>Privileged access is not configured or cannot be reached. Your normal local application remains available.</p><button type="button" className="btn btn-secondary" onClick={() => void load()}>Retry</button></section> : null}
      {status === 'ready' && session && catalogue ? <section className="card stack"><div className="spread"><div><h2 className="mt-0">Catalogue</h2><p className="hint">Signed in as {session.email}</p></div><span className="notice">Read Only</span></div><div className="admin-table-wrap"><table><tbody>{catalogue.values.map((row, rowIndex) => <tr key={rowIndex}>{row.map((value, columnIndex) => <td key={columnIndex}>{String(value)}</td>)}</tr>)}</tbody></table></div></section> : null}
      <p><Link className="btn btn-secondary" to="/settings">Back to Settings</Link></p>
    </div>
  );
}
